export default [
  {
    path: '/',
    title: '登录',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/pages/login/index.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/fileView',
    title: '新闻/政策',
    name: 'fileView',
    component: () => import(/* webpackChunkName: "login" */ '@/pages/login/fileView.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/help',
    title: '帮助',
    name: 'help',
    component: () => import(/* webpackChunkName: "help" */ '@/pages/help/index.vue'),
  },
  {
    path: '/toDoDetails',
    title: '详情',
    name: 'help',
    component: () => import(/* webpackChunkName: "toDoDetails" */ '@/pages/home/toDoMatters/component/toDoDetails.vue'),
  },
  {
    path: '/resetAccountApply',
    title: '申请账户重置',
    name: 'resetAccountApply',
    component: () =>
      import(
          /* webpackChunkName: "resetAccountApply" */ '@/pages/login/resetAccountApply.vue'
      ),
    meta: { noAuth: true }
  },
] 